module.exports = __webpack_public_path__ + "img/brand-cases13.e297eafc.png";